import { FC } from 'react';

const IllustrationCheck: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="81"
    fill="none"
    viewBox="0 0 80 81"
  >
    <path
      fill="#1D1D1D"
      d="M26.542 69.5q-1.838 0-2.895-1.188-1.03-1.19-1.03-3.178v-6.55h-1.615q-3.954 0-6.877-1.575t-4.538-4.532Q8 49.52 8 45.375V23.737q0-4.144 1.56-7.102a10.8 10.8 0 0 1 4.565-4.532q2.979-1.603 7.183-1.603h36.5q4.232 0 7.183 1.603 2.98 1.575 4.538 4.532 1.587 2.957 1.587 7.102v21.638q0 4.144-1.587 7.102-1.56 2.957-4.538 4.532-2.951 1.575-7.183 1.575H41.103l-9.466 8.29q-1.56 1.355-2.7 1.99a4.75 4.75 0 0 1-2.395.636m1.504-6.881 8.798-8.594q.919-.94 1.726-1.244.807-.332 2.144-.332H57.53q3.73 0 5.568-1.851 1.838-1.852 1.838-5.5V23.987q0-3.621-1.838-5.472t-5.568-1.851H21.587q-3.76 0-5.596 1.851-1.81 1.851-1.81 5.472v21.113q0 3.647 1.81 5.499 1.837 1.851 5.596 1.851h4.064q1.225 0 1.81.553.585.525.585 1.824z"
    ></path>
    <path
      fill="#0FBB0C"
      d="M55.737 30.329a3.297 3.297 0 0 0-3.688-5.468l-15.82 10.67a4 4 0 0 1-5.552-1.079l-1.451-2.15a3.297 3.297 0 0 0-5.467 3.687l5.697 8.447a3 3 0 0 0 4.165.81z"
    ></path>
  </svg>
);

export default IllustrationCheck;
